<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            COMPLIANCE / Taxation / Sales Tax
            <div class="settings-header__btn">
              <el-select v-model="taxType" @change="changeType" size="small" placeholder="Select">
                <el-option
                  v-for="item in taxTypeList"
                  :disabled="item.isDisabled"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>

          <el-tabs v-model="activeTabSTMInternal" @tab-click="handleClick">
            <el-tab-pane label="Tax Accounts" name="sTaxLibrary">
              <sTaxLibrary ref="sTaxLibrary"/>
            </el-tab-pane>
            <!-- <el-tab-pane label="GL (Tax Accounts)" name="sGL">
              <sGL ref="sGL"/>
            </el-tab-pane> -->
            <el-tab-pane label="Tax Management" name="taxReporting">
              <tax-reporting ref="taxReporting"/>
            </el-tab-pane>
            <!-- <el-tab-pane label="Summary List of Sales (Output)" name="summaryList">
              <summary-list ref="summaryList" />
            </el-tab-pane> -->
            <el-tab-pane label="Tax Reporting" name="salesTaxFiling">
              <sales-tax-filing ref="salesTaxFiling" />
            </el-tab-pane>
            <el-tab-pane label="BIR Certificates" name="sixth">{{msg}}</el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sTaxLibrary from '@/components/taxation/salesTaxPortal/sTaxLibrary.vue'
import axios from 'axios'
let moment = require('moment');
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import TaxReporting from "../components/taxation/salesTaxPortal/TaxReporting";
import SalesTaxFiling from "../components/taxation/salesTaxPortal/SalesTaxFiling";
import SummaryList from "../components/taxation/salesTaxPortal/SummaryList";

export default {
  name: 'Taxation',
  components: {
    SweetModal,
    sTaxLibrary,
    TaxReporting,
    SummaryList,
    SalesTaxFiling,
  },
  data() {
    return {
      tableData: [],
      activeTabSTMInternal: 'sTaxLibrary',
      msg: 'Sorry, this feature now under development will be ready later.',
      taxType: 'taxation-sales',
      taxTypeList: [
        { id: 1, name: 'Sales Tax (Vatable)', isDisabled: true, value: 'taxation-sales' },
        { id: 2, name: 'Withholding Tax Expanded', isDisabled: false, value: 'taxation-withholding' },
        { id: 3, name: 'Income Tax', isDisabled: true, value: 'taxation-income' },
      ],
    }
  },
  mounted () {
    this.$refs['sTaxLibrary'].loadList()
  },
  methods: {
    changeType(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    handleClick(tab, event) {
      if (tab.name === 'first'){
        this.activeTabSTMInternal = 'sTaxLibrary'
        this.$refs['sTaxLibrary'].loadList()
      } else if (tab.name === 'summaryList') {
        this.$refs['summaryList'].loadList()
      }

      if (tab.name === 'sTaxLibrary'){
        this.$refs['sTaxLibrary'].loadList()
      } else if (tab.name === 'taxReporting') {
        this.$refs['taxReporting'].loadFirstTab()
      } else if (tab.name === 'salesTaxFiling') {
        this.$refs['salesTaxFiling'].loadFirstTab()
      }

    }
  },
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
      .settings-header {
        display: flex;
        justify-content: space-between;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
